import React, { useState } from "react";
import { Link } from "react-router-dom";
import { navigation } from "../../../config/layout/header";
import { Medias } from "../../components/Medias";
import { Icon } from "@/components";
import { IconButton, Tooltip } from "@/ui";
import iconButtonStyles from "@/ui/components/IconButton/IconButton.module.scss";
import styles from "./HeaderOptions.module.scss";

const HeaderOptions = () => {
    const [isMediasOpen, setIsMediasOpen] = useState(false);

    return (
        <>
            {navigation.map((link, i) => {
                const key = `header-option-${link.slug ?? link.route ?? i}`;

                const icon = <Icon color={link.color} icon={link.icon} />;

                if (link.slug === "medias") {
                    return (
                        <div className={styles.item} key={key}>
                            <Tooltip content={link.label}>
                                <IconButton
                                    aria-label={link.label}
                                    onClick={() => setIsMediasOpen(true)}
                                    rounded
                                    type="button"
                                    variant="tertiary"
                                >
                                    {icon}
                                </IconButton>
                            </Tooltip>
                            <Medias
                                isOpen={isMediasOpen}
                                toggle={() => setIsMediasOpen(false)}
                            />
                        </div>
                    );
                }

                if (typeof link.route === "string") {
                    return (
                        <div className={styles.item} key={key}>
                            <Tooltip content={link.label}>
                                <Link
                                    aria-label={link.label}
                                    className={`${iconButtonStyles.root} ${iconButtonStyles.rounded}`}
                                    data-rounded
                                    data-size="md"
                                    data-ui="icon-button"
                                    data-variant="tertiary"
                                    to={link.route}
                                >
                                    {icon}
                                </Link>
                            </Tooltip>
                        </div>
                    );
                }

                return null;
            })}
        </>
    );
};

export default HeaderOptions;
